module.exports = __webpack_public_path__ + "img/TurningStool4.b12b579a.jpg";